import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "box overflow sendSetting" }
const _hoisted_2 = { class: "settingBlockContainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "템플릿 발송 전 알림", -1)
const _hoisted_4 = { class: "settingBlockArea" }
const _hoisted_5 = { class: "settingBlock left poRel" }
const _hoisted_6 = { class: "settingBlockText left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7시", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8시", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9시", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10시", -1)
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "당일", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1일전", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2일전", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3일전", -1)
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockword left mgL15" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "예약된 템플릿 메시지가 있는 경우 지정된 시간에 미리 알림을 받습니다. "),
    /*#__PURE__*/_createElementVNode("li", null, "JSD 어플이 설치되어 있지 않은 경우, 알림 메시지가 발송되지 않습니다. ")
  ])
], -1)
const _hoisted_18 = { class: "settingBlockArea" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "주말, 공휴일 발송 여부", -1)
const _hoisted_20 = { class: "settingBlockArea" }
const _hoisted_21 = { class: "settingBlock left poRel" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockText left" }, "주말,공휴일 발송여부", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "settingBlockword left mgL15" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "템플릿 문자의 발송일이 주말(토/일요일)이나 공휴일인 경우 다음 평일에 발송합니다. ")
  ])
], -1)
const _hoisted_24 = { class: "conBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            ($data.api.AUMS_NOTI_YN == 'Y')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "blueBtn",
                  style: {"margin-top":"0"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.api.AUMS_NOTI_YN='N'))
                }, "발송"))
              : _createCommentVNode("", true),
            ($data.api.AUMS_NOTI_YN == 'N')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "redBtn",
                  style: {"margin-top":"0"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.api.AUMS_NOTI_YN='Y'))
                }, "발송안함"))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "selectBox right",
            style: {"margin-left":"10px"},
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.api.AUMS_NOTI_TM) = $event))
          }, _hoisted_11, 512), [
            [_vModelSelect, $data.api.AUMS_NOTI_TM]
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "selectBox right",
            style: {"margin-right":"0"},
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.api.AUMS_NOTI_DAY) = $event))
          }, _hoisted_16, 512), [
            [_vModelSelect, $data.api.AUMS_NOTI_DAY]
          ])
        ]),
        _hoisted_17
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("button", {
            class: "blueBtn right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.api.AUMS_HOLI_SEND_YN='N'))
          }, "발송", 512), [
            [_vShow, $data.api.AUMS_HOLI_SEND_YN == 'Y']
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "redBtn right",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.api.AUMS_HOLI_SEND_YN='Y'))
          }, "발송안함", 512), [
            [_vShow, $data.api.AUMS_HOLI_SEND_YN == 'N']
          ])
        ]),
        _hoisted_23
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        class: "grayBtn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.getConfList()))
      }, " 취소 "),
      _createTextVNode("   "),
      _createElementVNode("button", {
        class: "blueBtn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.conf_save()))
      }, " 저장 ")
    ])
  ]))
}